import { Box, styled } from '@mui/material';

import { palette } from '../../../../../theme';
export const PanelHeaderBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 12px',
  borderBottom: `1px solid ${palette.line}`,
  height: 60
});
